import { ColoringNone } from '@/api/api';

interface ColoringNoneFormProps {
  coloring: ColoringNone;
  onChange: (coloring: ColoringNone) => void;
  disabled?: boolean;
}

export default function ColoringNoneForm({ coloring, onChange, disabled }: ColoringNoneFormProps) {
  return (
    <div className="bg-gray-50 p-3 rounded">
      <p className="text-sm text-gray-600">No coloring applied to this data source.</p>
    </div>
  );
}
